export default "__VITE_ASSET__B4j0cKg9__"